import type { User } from '@/providers/AuthProvider/User';
import { createContext } from 'react';

interface UserFunctionsContextInterface {
  setUser: (user: User | null) => void;
  // setIsAuthenticated: Dispatch<SetStateAction<boolean>>
}
const USER_FUNCTIONS_CONTEXT__DEFAULT_VALUE = {
  setUser: () => null,
  // setIsAuthenticated: () => null
};
export const UserFunctionsContext =
  createContext<UserFunctionsContextInterface>(
    USER_FUNCTIONS_CONTEXT__DEFAULT_VALUE,
  );
